module.exports = __webpack_public_path__ + "static/media/img .7d89040c.png";